import Layout from "../../../../src/components/layout";
import { Link } from "gatsby";
import styled from "styled-components";
import { PrimaryButton } from "../../../../src/components/Buttons";
import { SecondaryButton } from "../../../../src/components/Buttons";
import "../../../../src/pages/coverage/form.css";
import React from 'react';
export default {
  Layout,
  Link,
  styled,
  PrimaryButton,
  SecondaryButton,
  React
};